/**
 * File: createActivity.js
 * Project: educore
 * Created Date: 2018-12-10
 * Author: Jeevanantham Nagarathinam
 * Screen : FE162
 * -----
 * Last Modified: 2018-12-10
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

//import templatePopLoader from '../../generic/views/loader.html';
//import teacherSubViewTpl from '../views/teacherSubjectView.html';

import titlesPopup from '../views/titles-popup.html'

class CreateActivityController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, CONSTANTS, archiveService, QP_HANDLING_CONSTANTS, $stateParams) {

        let self = this;
        //CurrentPage.setTitle("Create Activity")
        $scope.schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        $scope.isPractice = false
        let academicDetails = localStorageService.get('academicDetails')
        let authoring = localStorageService.get('authoringData')
        let currTimeunix = Math.floor(Date.now() / 1000);
        $scope.userToredir = btoa(localStorageService.get('username'))+"_"+currTimeunix;
        console.log($scope.userToredir)
        if(!authoring){
            $state.go("dashboard")
        }
        let authoringData = {
            class_id:authoring.class_id,
            curriculum_id:authoring.curriculum_id,
            batch_id:authoring.batch_id,
            subject_id:authoring.subject_id,
            session_id:authoring.session_id,
            school_id:authoring.school_id,
            batch:authoring.batch,
            class:authoring.class,
            subject:authoring.subject,
            session:authoring.session,
            curriculum:authoring.curriculum,
            academic_year:authoring.academic_year
        }
        $scope.qp_handler = {}
        $scope.qp_handler['is_visibleto_parents'] = true
        $scope.themeselection = {}
        $scope.themeselection.type = 'multiple'
        $scope.qp_type = {}
        let normal_type = {
            _id : "normal",
            name : "General"
        }
        let LO_TEXT = "Learning Outcome"
        let WT_TEXT = "Wrap Up Test"
        let LO_ID = "learning_outcome"
        let WT_ID = "wrapup_test"
        $scope.activity_types = [{
            _id : LO_ID,
            name : LO_TEXT
        },{
            _id : WT_ID,
            name : WT_TEXT
        },normal_type]
        $scope.qp_type['activity_type'] = normal_type._id
        $scope.is_qp_type_lW = false
        $scope.isTWWTCLASSES = false
        let new_activity_types= [{
            _id : LO_ID,
            name : LO_TEXT
        },{
            _id : WT_ID,
            name : WT_TEXT
        }]
        $scope.titles = []
        $scope.titleitem = {}
        $scope.error_div = {
            msg : null,
            has_error : false
        }
        $scope.tracker_obj = {
            is_tracker : false
        }
        function nullErrorDiv(){
            $scope.error_div = {
                msg : null,
                has_error : false
            }
        }
        function msgErrorDiv(msg = null){
            $scope.error_div = {
                msg : msg,
                has_error : true
            }
        }
        function lTcreationLimitErr(){
            let str = ''
            if($scope.qp_type && $scope.qp_type['activity_type']){
                if($scope.qp_type['activity_type'] == LO_ID){
                    str = "Sorry. Cannot proceed. " + LO_TEXT + " activities limit exceeded. Please change the topic (theme)."
                }
                if($scope.qp_type['activity_type'] == WT_ID){
                    str = "Sorry. Cannot proceed. " + WT_TEXT + " activities limit exceeded. Please change the topic (theme)."
                }
            }
            msgErrorDiv(str)
            $scope.$apply()
            toastr.error(str)
        }
        function validateLearningTracker(callBack){
            nullErrorDiv()
            try{
                if(!$scope.isTWWTCLASSES){
                    callBack(true)
                    return
                }
                if(!$scope.is_qp_type_lW){
                    callBack(true)
                    return
                }
                let url = "/v0/traditional/qp/validate/learning/tracker"
                let isEdit = false
                if($scope.qpId){
                    isEdit = true
                }
                let obj = {
                    authoringData : authoringData,
                    qp_type : $scope.qp_type,
                    theme : $scope.theme[0],
                    isEdit : isEdit,
                    qpId : $scope.qpId,
                    userId : userId
                }
                authService.callAPI(url, "POST", obj, (response) => {
                    try{
                        if (response.result && response.result.data) {
                            callBack(response.result.data.details)
                        } else {
                            callBack(true)
                        }
                    }catch(er){
                        console.log(er)
                        callBack(true)
                    }
                })
            }catch(e){
                callBack(true)
            }
        }
        $scope.showTitlesInPoUp = () => {
            if([LO_ID, WT_ID].indexOf($scope.qp_type.activity_type) !== -1){
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'parentScope', 'titles', 'authoringData', 'authService','userId',
                     titlePopUpController],
                    locals: {
                        "parentScope" : $scope,
                        titles : $scope.titles,
                        authoringData : authoringData,
                        authService : authService,
                        userId : userId
                    },
                    template: titlesPopup,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    // fullscreen: useFullScreen
                })
            }
        }
        var LWWT_REQUIRED_CLASSES = []
        var LWWT_REQUIRED_SUBJECTS = []
        if(QP_HANDLING_CONSTANTS){
            if(QP_HANDLING_CONSTANTS.QP_NOTVISBLE_DEFAULT_PARENT_SCHOOLS && 
                QP_HANDLING_CONSTANTS.QP_NOTVISBLE_DEFAULT_PARENT_SCHOOLS.indexOf(
                    localStorageService.get("school_id")
                ) !== -1){
                    $scope.qp_handler['is_visibleto_parents'] = false
                } 
        }
        $scope.disableFilter = false
        $scope.qpId = $state.params.qpId
        $scope.activityId = $state.params.activityId
        
        let whiteFeatureList = ['createQuestion', 'selectQuestion', 'selectTemplate', 'selectQuestionPaper']


        //[Object] - List of features menu
        $scope.featuresList = [{
            "_id": "createQuestion",
            "name": "Create Question",
            "state": "createQuestion",
            "icon": "../../../../img/icons/create-question.png",
            "color": "#f16e02"
        }, {
            "_id": "selectQuestion",
            "name": "Select Question",
            "state": "selectQuestion",
            "icon": "../../../../img/icons/select-question.png",
            "color": "#00b4bd"
        }, {
            "_id": "selectTemplate",
            "name": "Select Template",
            "state": "selectTemplate",
            "icon": "../../../../img/icons/question-template.png",
            "color": "#f35966"
        }, {
            "_id": "selectQuestionPaper",
            "name": "Select Question Paper",
            "state": "selectQuestionPaper",
            "icon": "../../../../img/icons/archives.png",
            "color": "#00ba9c"
        }];

        let isLWisLW = (qp_doc) => {
            let ret = false
            try{
                let typeids = _.pluck(new_activity_types, "_id")
                if(qp_doc){
                    if(qp_doc.qp_type && qp_doc.qp_type.activity_type && 
                        typeids.indexOf(qp_doc.qp_type.activity_type) !== -1){
                            ret = true
                        }
                }
                return ret
            }catch(e){
                console.log(e)
                ret = false
                return ret
            }
        }
        function setRadio(qp_doc = {}){
            if(qp_doc.qp_type){
                $scope.qp_type.activity_type = qp_doc.qp_type.activity_type
            }
        }
        let __IS_AUTO_WRAPUP = false
        let setUiIfFromTracker = () => {
            if(__IS_AUTO_WRAPUP){
                $scope.themeselection.type = 'single'
                $scope.tracker_obj.is_tracker = true
            }else{
                $scope.themeselection.type = 'multiple'
                $scope.tracker_obj.is_tracker = false
            }
        }
        let getActivity = (obj) => {
            console.log('getActivity')
            authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.data.data) {
                    let result = response.result.data.data[0]
                    console.log(result)
                    if(result.basic_details[0]['qp_type']){
                        $scope.qp_type['activity_type'] = result.basic_details[0]['qp_type'].activity_type
                        $scope.is_qp_type_lW = isLWisLW(result.basic_details[0])
                        if(result.basic_details[0].auto_wrapup){
                            __IS_AUTO_WRAPUP = true
                            $scope.theme = result.basic_details[0].theme_id[0]
                        }else{
                            $scope.theme = result.basic_details[0].theme_id
                        }
                    }
                    $scope.disableFilter = true
                    $scope.activityResult = result

                    $scope.qpTitle = result.basic_details[0].question_paper_title
                    $scope.isPractice = result.basic_details[0].practice_qn
                    setUiIfFromTracker()
                } else {
                    //error
                }
                console.log($scope.qp_type)
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }

        let getThemeData = () => {
            authoringData['isLwWT'] = true
            authService.callAPI(activityCons.API_GET_THEMES, "POST", authoringData, (response) => {
                if (response.result && response.result.status && response.result.data.themeList) {
                    $scope.themes = response.result.data.themeList;
                    LWWT_REQUIRED_CLASSES = response.result.data.required_classes
                    LWWT_REQUIRED_SUBJECTS = response.result.data.required_subjects
                    if(LWWT_REQUIRED_CLASSES.indexOf(authoring.class_id) !== -1){
                        if(LWWT_REQUIRED_SUBJECTS.indexOf(authoring.subject_id) !== -1){
                            $scope.isTWWTCLASSES = true
                        }
                    }
                    if(response.result.data.titles && 
                        response.result.data.titles.length){
                            $scope.titles = response.result.data.titles
                        }
                    console.log($scope.titles)
                     _.defer(function() {
                        $scope.$apply();
                    });
                } else {
                    //error
                }
            })

            _.defer(function() {
                $scope.$apply();
            });
        }

        let addActivityToQp = (academic_details, res) => {
            authService.callAPI(activityCons.API_ADD_ACTIVITY_TO_QP, "POST", academic_details, (response) => {
                if (response.result && response.result.status && response.result.data.data) {
                    res(response.result.data.data);
                } else {
                    console.log(response)
                }
            })
        }

        let updateActivityToQp = (qp_id, title, theme, res) => {
            let obj = {
                qpId: qp_id,
                qpTitle: title,
                theme: theme,
                qp_type : $scope.qp_type
            }
            obj['is_visibleto_parents'] = $scope.qp_handler['is_visibleto_parents'];
            authService.callAPI(activityCons.API_UPDATE_ACTIVITY_QP, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.data.details) {
                    res(response.result.data.details);
                } else {
                    //error
                }
            })
        }

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity List"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            if(!authoring){
                $state.go("dashboard")
            }
            if ($scope.qpId) {
                let obj = {
                    "qp_id": $scope.qpId,
                    "teacher_id": localStorageService.get("user_id"),
                    "school_id": localStorageService.get("school_id")
                }
                getActivity(obj)
            }

            getThemeData()
        }


        let redirectDetails = archiveService.getRedirectJson();
        archiveService.clearRedirectJson();
        if (redirectDetails) {
            $scope.isLoading = true;
            console.log('academicDetails', academicDetails)
            $scope.qpTitle = academicDetails.question_paper_title;
            $scope.theme = academicDetails.theme_id
            if (redirectDetails.returnData) {
                let academicDetails = localStorageService.get('academicDetails')
                if (redirectDetails.activeTab == "qp") {
                    let archiveQpId = redirectDetails.returnData.resource._id;
                    academicDetails["archive_qp_id"] = archiveQpId
                    authService.callAPI(activityCons.API_SELECT_QP, "POST", academicDetails, (response) => {
                        if (response.result && response.result && response.result.data) {
                            let qpId = response.result.data._id
                            $state.go('activityPreview', {
                                qpId: qpId
                            })
                        }
                    })
                } else if (redirectDetails.activeTab == "question") {
                    let ques_ids = [];
                    _.each(redirectDetails.returnData, function(questionArchive) {
                        ques_ids.push(questionArchive.resource._id)
                    })
                    academicDetails['ques_ids'] = ques_ids
                    authService.callAPI(activityCons.API_SELECT_QUESTION, "POST", academicDetails, (response) => {
                        if (response.result && response.result && response.result.data) {
                            let qpId = response.result.data.qp_id
                            $state.go('formatQuestion', {
                                qpId: qpId
                            })
                        }
                    })
                } else if (redirectDetails.activeTab == "qp_template") {
                    let qpId = redirectDetails.returnData.resource._id;
                    academicDetails["qp_id"] = qpId
                    academicDetails["title"] = qpId
                    authService.callAPI(activityCons.API_SELECT_TEMPLATE, "POST", academicDetails, (response) => {
                        if (response.result && response.result && response.result.data) {
                            let questioPaperId = response.result.data.data._id
                            $state.go('activityPreview', {
                                qpId: questioPaperId
                            })
                        }
                    })
                } else {
                    $scope.isLoading = false;
                }
            } else {
                $scope.isLoading = false;
            }
        }


        $scope.qpTitleChange = () => {
            $scope.isTitleChanged = true
        }
        $scope.onSelectChange = (type, theme_id) => {
            nullErrorDiv()
            if(type == 'single'){
                $scope.theme = [theme_id]
            }else{
                $scope.theme = theme_id
            }
            $scope.isThemeChanged = true
        }

        /*
         * To navigate to selected page
         * 
         * @feature : Object - Selected feature detail
         * 
         * @return : null
         *
         * 
         */

        $scope.navigatePage = function(feature) {
            nullErrorDiv()
            if ($scope.theme && $scope.qpTitle) {
                academicDetails = authoringData


                academicDetails['theme_id'] = $scope.theme
                academicDetails['question_paper_title'] = $scope.qpTitle
                academicDetails['practice_qn'] = $scope.isPractice
                academicDetails['isNotAddToQp'] = false
                academicDetails['is_traditional_activity'] = true
                academicDetails['isQuestionAvailable'] = false
                academicDetails['qp_id'] = $scope.qpId
                academicDetails['teacher_id'] = userId
                academicDetails['is_visibleto_parents'] = $scope.qp_handler['is_visibleto_parents']
                academicDetails['qp_type'] = $scope.qp_type
                $scope.is_qp_type_lW = isLWisLW(academicDetails)
                academicDetails['is_qp_type_lW'] = $scope.is_qp_type_lW
                $scope.currentTheme = _.find($scope.themes, function(theme) {
                    return theme._id === $scope.theme
                })
                console.log(feature._id, academicDetails)
                $scope.selectedActivity = feature;
                switch (feature._id) {
                    case 'createQuestion':
                        if (!$scope.qpId) {
                            academicDetails["academic_year"] = localStorageService.get("activeAcdYear");
                            //checks limits of learning tracker
                            validateLearningTracker(function(canContinue){
                                console.log(canContinue)
                                if(canContinue){
                                    addActivityToQp(academicDetails, (result) => {
                                        console.log(result)
                                        academicDetails['qp_id'] = result._id
                                        localStorageService.set('academicDetails', academicDetails)
                                        localStorageService.set("createQuesiton", {
                                            state: "tactivity",
                                            qp_id: result._id,
                                            qp_title: result.question_paper_title,
                                            activity_id: result.activity_id,
                                            theme_id: result.theme_id,
                                            class_id: authoringData.class_id,
                                            curriculum_id: authoringData.curriculum_id,
                                            subject_id: authoringData.subject_id,
                                            batch_id: authoringData.batch_id,
                                            session_id: authoringData.session_id,
                                            school_id: authoringData.school_id,
                                            practice_qn: $scope.isPractice,
                                            academic_year: localStorageService.get("activeAcdYear"),
                                            is_visibleto_parents : $scope.qp_handler['is_visibleto_parents'],
                                            qp_type : $scope.qp_type,
                                            is_qp_type_lW : $scope.is_qp_type_lW
                                        })
                                        $state.go(feature.state)
                                    })
                                }else{
                                    //limiting learning tracker err handling
                                    lTcreationLimitErr()
                                }
                            })
                        } else {
                            validateLearningTracker(function(canContinue){
                                if(canContinue){
                                    if ($scope.isTitleChanged || $scope.isThemeChanged)
                                    academicDetails['question_paper_title'] = $scope.qpTitle;
                                    academicDetails["academic_year"] = localStorageService.get("activeAcdYear");
                                    localStorageService.set('academicDetails', academicDetails)
                                    localStorageService.set("createQuesiton", {
                                        state: "tactivity",
                                        class_id: authoringData.class_id,
                                        curriculum_id: authoringData.curriculum_id,
                                        subject_id: authoringData.subject_id,
                                        batch_id: authoringData.batch_id,
                                        session_id: authoringData.session_id,
                                        school_id: authoringData.school_id,
                                        practice_qn: $scope.isPractice,
                                        qp_id: $scope.qpId,
                                        qp_title: $scope.qpTitle,
                                        activity_id: $scope.activityId,
                                        theme_id: $scope.theme,
                                        academic_year: localStorageService.get("activeAcdYear"),
                                        is_visibleto_parents : $scope.qp_handler['is_visibleto_parents'],
                                        qp_type : $scope.qp_type,
                                        is_qp_type_lW : $scope.is_qp_type_lW
                                    })
                                    updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, (result) => {
                                        $state.go(feature.state)
                                    })
                                }else{
                                    //limiting learning tracker err handling
                                    lTcreationLimitErr()
                                }
                            })
                            
                        }

                        break;
                    case 'selectQuestionPaper':
                        validateLearningTracker(function(canContinue){
                            if(canContinue){
                                academicDetails["qp_id"] = $scope.qpId
                                academicDetails['question_paper_title'] = $scope.qpTitle;

                                updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, (result) => {
                                    localStorageService.set('academicDetails', academicDetails)
                                    goToArchive({
                                        tabId: "qp",
                                        searchFilterId: "qp",
                                        name: 'Select Question Paper'
                                    }, false);
                                })
                            }else{
                                lTcreationLimitErr()
                            }
                        })
                        
                        break;
                    case 'selectQuestion':
                        validateLearningTracker(function(canContinue){
                            if(canContinue){
                                academicDetails["qp_id"] = $scope.qpId
                                academicDetails['question_paper_title'] = $scope.qpTitle;
                                if ($scope.isTitleChanged)
                                    academicDetails['question_paper_title'] = $scope.qpTitle;

                                updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, (result) => {
                                    localStorageService.set('academicDetails', academicDetails)
                                    goToArchive({
                                        tabId: 'question',
                                        searchFilterId: 'question',
                                        name: "Select Question"
                                    }, true);
                                })
                            }else{
                                lTcreationLimitErr()
                            }
                        })
                        break;
                    case 'selectTemplate':
                        academicDetails["qp_id"] = $scope.qpId
                        academicDetails['question_paper_title'] = $scope.qpTitle;
                        updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, (result) => {
                            localStorageService.set('academicDetails', academicDetails)
                            goToArchive({
                                tabId: 'qp_template',
                                searchFilterId: 'qp',
                                name: "Select Template"
                            }, false)
                        })
                        break;
                    default:
                        this.state.go("createActivity");
                        break;
                }
            } else {
                toastr.error('Please select theme and question paper title')
            }
        }

        var goToArchive = (type, isMultiSelect) => {

            let teachingPlan = $scope.teachingPlan;
            let searchFilters = [];
            let authoring = localStorageService.get('authoringData')
            searchFilters.push({
                type: 'curriculum',
                value: {
                    _id: authoring.curriculum_id,
                    name: authoring.curriculum
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: 'class',
                value: {
                    _id: authoring.class_id,
                    name: authoring.class
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: 'subject',
                value: {
                    _id: authoring.subject_id,
                    name: authoring.subject
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: "tab",
                value: {
                    _id: type.tabId,
                    name: type.name
                },
                deletable: false,
                visible: false
            });
            if ($scope.isPractice && type.searchFilterId == 'qp') {
                searchFilters.push({
                    type: "exam_type",
                    value: {
                        _id: "Practice",
                        name: "Practice Exam"
                    },
                    deletable: false,
                    visible: true
                })
            }
            if (!$scope.isPractice && type.searchFilterId == 'qp') {
                searchFilters.push({
                    type: "exam_type",
                    value: {
                        _id: "Assesment",
                        name: "Assessment Exam"
                    },
                    deletable: false,
                    visible: true
                })
            }
            let details = {
                searchFilters: searchFilters,
                previousState: {
                    state: $state.current.name,
                    params: $state.params
                },
                isMultiSelect: isMultiSelect,
                isPractice: $scope.isPractice,
                activeTab: type.tabId,
                resource: this.resource,
                resourceType: {
                    _id: type.searchFilterId,
                    name: type.name
                },
                isPractice: $scope.isPractice
            }
            archiveService.setRedirectJson(details)
            $state.go("archives");
        }
        function _breakReference(data, arrayOfKeys = []) {
            let keys = Object.keys(data)
            if(arrayOfKeys && arrayOfKeys.length){
                keys = arrayOfKeys
            }
            let obj = {}
            for (let k = 0; k < keys.length; k++) {
                obj[keys[k]] = data[keys[k]]
            }
            return obj
        }
        function cleartitle(){
            $scope.qpTitle = ''
        }
        $scope.selectActType = (model_type) => {
            cleartitle()
            if($scope.qp_type && $scope.qp_type.activity_type == 'normal'){
                $scope.theme = undefined
                $scope.themeselection.type = 'multiple'
            }else{
                if($scope.themeselection.type == 'single'){
                    
                }else{
                    $scope.themeselection.type = 'single'
                    $scope.theme = undefined
                }
            }
            let obj = {}
            obj.qp_type = $scope.qp_type
            $scope.is_qp_type_lW = isLWisLW(obj)
        }
    }
}
export default CreateActivityController;
class titlePopUpController {
    constructor($scope, $mdDialog, parentScope, titles, authoringData, authService, userId) {
        $scope.modal = {}
        $scope.modal['title'] = "Select Question Paper Title"
        $scope.titleitem = {}
        $scope.titleitem.canContinue = true
        $scope.titles = []
        $scope.selections = {}
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.saveAction = function () {
            parentScope.qpTitle = getTitleTxt()
            toastr.success("Question paper title selected.")
            $mdDialog.cancel();
        };
        function getTitleTxt(){
            let ret = null
            let exists = _.find($scope.titles, function(one){
                return one._id == $scope.titleitem.qpTitle
            })
            if(exists){
                ret = exists.title
            }
            return ret
        }
        function getThemeTxt(){
            let ret = ''
            let exists = _.find(parentScope.themes, function(one){
                return one.theme_id == parentScope.theme[0]
            })
            if(exists){
                ret = exists.theme_name
            }
            return ret
        }
        $scope.validateTitle = function (){
            if(parentScope.theme && parentScope.theme.length){
                let isEdit = false
                if(parentScope.qpId){
                    isEdit = true
                }
                
                let obj = {
                    authoringData : authoringData,
                    qp_type : parentScope.qp_type,
                    theme : parentScope.theme[0],
                    isEdit : isEdit,
                    qpId : parentScope.qpId,
                    title :getTitleTxt(),
                    userId : userId
                }
                let url = "/v0/validate/qp/title"
                authService.callAPI(url, "POST", obj, (response) => {
                    
                    try{
                        if (response.result && response.result.data) {
                            $scope.titleitem.canContinue = response.result.data.details
                        }
                    }catch(er){
                        console.log(er)
                    }
                    $scope.$apply()
                })
                console.log(obj)
            }
        }
        this.$onInit = () => {
            $scope.titles = titles
            $scope.titleitem.theme_txt = getThemeTxt()
            console.log(parentScope.theme)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/createActivity.js